/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
/* eslint-disable-next-line no-restricted-globals */
const React = require('react');
const { useDebounce } = require('../utils/debounce');
const { useLiveDemoContext } = require('../base-live-demo-component/Provider/liveDemoContext');
const { brickCreationScriptBlue, brickCreationScriptYellow, testCredentials } = require('./constants');
const { isPublicKeyYellowBrand, finalPublicKey } = require('./utils');
const PreferencesService = require('../../../../services/preferencesService');

const View = ({
  publicKey,
  action,
  valueProp,
  theme,
  redirectMode,
  showValueProp = true,
  buttonBackground,
  valuePropColorYellowBrand,
  valuePropColorBlueBrand,
  buttonHeight,
  buttonWidth,
  borderRadius,
  verticalPaddingBlueBrand,
  verticalPaddingYellowBrand,
  horizontalPadding,
  elementsColor,
  headerColor,
  language,
  brand,
}) => {
  const debounceProps = [
    useDebounce(publicKey, 2000),
    useDebounce(action, 2000),
    useDebounce(valueProp, 2000),
    useDebounce(theme, 2000),
    useDebounce(redirectMode, 2000),
    useDebounce(showValueProp, 2000),
    useDebounce(buttonBackground, 2000),
    useDebounce(valuePropColorBlueBrand, 2000),
    useDebounce(valuePropColorYellowBrand, 2000),
    useDebounce(buttonHeight, 2000),
    useDebounce(buttonWidth, 2000),
    useDebounce(borderRadius, 2000),
    useDebounce(verticalPaddingBlueBrand, 2000),
    useDebounce(verticalPaddingYellowBrand, 2000),
    useDebounce(horizontalPadding, 2000),
    useDebounce(elementsColor, 2000),
    useDebounce(headerColor, 2000),
    useDebounce(language, 2000),
    useDebounce(brand, 2000),
  ];
  const { setBehaviorData, formData } = useLiveDemoContext();

  const isYellowBrand = isPublicKeyYellowBrand(publicKey, formData.brand?.brand);
  const isContainerDark = ([buttonBackground].includes('white') && !isYellowBrand)
  || ([valuePropColorYellowBrand].includes('white') && ![theme].includes('dark') && isYellowBrand)
  || ([valuePropColorBlueBrand].includes('white') && !isYellowBrand);

  const containerTitle = {
    pt: 'Sua loja',
    es: 'Tu tienda',
    en: 'Your store',
    'pt-BR': 'Sua loja',
    'es-AR': 'Tu tienda',
    'en-US': 'Your store',
  };

  const brickCreationScript = isYellowBrand ? brickCreationScriptYellow : brickCreationScriptBlue;

  React.useEffect(() => {
    const cachedPreferenceId = localStorage.getItem('preferenceId');
    const cachedAccessToken = localStorage.getItem('accessToken');
    const cachedPreferenceIdExpiration = localStorage.getItem('preferenceIdExpiration');
    let preferenceId = cachedPreferenceId;

    const getHideComponents = (value) => {
      switch (value) {
        case 'security_safety': return ['onboardingCreditsMessage', 'convenienceAllonboardingCreditsMessage'];
        case 'security_details': return ['onboardingCreditsMessage', 'convenienceAllonboardingCreditsMessage'];
        case 'convenience_all': return ['onboardingCreditsMessage'];
        case 'practicality': return ['onboardingCreditsMessage', 'convenienceAllonboardingCreditsMessage'];
        case 'convenience_credits': return [];
        case 'smart_option': return ['onboardingCreditsMessage', 'convenienceAllonboardingCreditsMessage'];
        default: return [];
      }
    };

    const setWalletBricksPropsAndEval = (props, script, delay) => {
      window.walletBricksProps = props;
      setTimeout(() => {
        setBehaviorData(prev => ({
          ...prev,
          showLayoutSpinner: false,
          disabledComponents: !showValueProp ? ['valuePropColorBlueBrand', 'valuePropColorYellowBrand', 'valueProp'] : [],
          hideComponents: getHideComponents(valueProp),
        }));
        window.eval(brickCreationScript);
      }, delay);
    };

    const { accessToken } = testCredentials.find(item => item.publicKey === publicKey);

    const fPublicKey = finalPublicKey(publicKey, (brand || formData.brand?.brand));

    const createWalletBricksProps = () => ({
      publicKey: fPublicKey || 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
      action: action || 'pay',
      valueProp: valueProp || 'security_safety',
      theme: theme || 'default',
      redirectMode: redirectMode || 'self',
      buttonWidth: buttonWidth || '270px',
      styleProperties: {
        hideValueProp: !showValueProp || false,
        buttonBackground: buttonBackground || 'default',
        valuePropColor: isYellowBrand ? valuePropColorYellowBrand || 'blue' : valuePropColorBlueBrand || 'grey',
        buttonHeight: `${buttonHeight}px` || '48px',
        borderRadius: `${borderRadius}px` || '6px',
        verticalPadding: isYellowBrand ? `${verticalPaddingYellowBrand}px` || '8px' : `${verticalPaddingBlueBrand}px` || '16px',
        horizontalPadding: `${horizontalPadding}px` || '16px',
        elementsColor: `#${elementsColor}` || '',
        headerColor: `#${elementsColor}` || '',
      },
      language: language || 'pt-BR',
      preferenceId: preferenceId || '',
    });

    if (Date.now() > Number(cachedPreferenceIdExpiration) || accessToken !== cachedAccessToken || !preferenceId || preferenceId === '' || preferenceId === 'undefined') {
      (async () => {
        const preference = await PreferencesService.postPreferences(accessToken);
        preferenceId = preference?.id;
        const preferenceIdExpirationTime = Date.now() + 10 * 60 * 60 * 1000;

        if (preferenceId) {
          localStorage.setItem('preferenceId', preferenceId);
        }
        localStorage.setItem('preferenceIdExpiration', preferenceIdExpirationTime);
        localStorage.setItem('accessToken', accessToken);

        const props = createWalletBricksProps();

        setWalletBricksPropsAndEval(props, brickCreationScript, 1000);
      })();
    } else {
      const props = createWalletBricksProps();
      setWalletBricksPropsAndEval(props, brickCreationScript, 1000);
    }
  }, [
    ...debounceProps,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);
    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);

  addEventListener('walletBrickReady', () => {
    setBehaviorData(prev => ({
      ...prev,
      showLayoutSpinner: false,
    }));
  });

  return (
    <>
      <div className={`wallet-brick-form__main-container${isContainerDark ? '--dark' : ''}`}>
        <div className={`wallet-brick-form__title${isContainerDark ? '--dark' : ''}`}>
          <p>
            {containerTitle[language] || 'Tu tienda'}
          </p>
        </div>
        <div className="wallet-brick-form__white-field" />
        <div className="wallet-brick-form__white-field" />
        <div className="wallet-brick-form__two-columns">
          <div className="wallet-brick-form__white-field" />
          <div className="wallet-brick-form__divisor" />
          <div className="wallet-brick-form__white-field" />
        </div>
        <div className="wallet-brick-form__button-container" style={{ maxWidth: buttonWidth }}>
          <div id="walletBrick_container" />
        </div>
      </div>
    </>
  );
};

module.exports = View;
